import { render, staticRenderFns } from "./LocationsView.vue?vue&type=template&id=2f9a2312&scoped=true&"
import script from "./LocationsView.vue?vue&type=script&lang=js&"
export * from "./LocationsView.vue?vue&type=script&lang=js&"
import style0 from "./LocationsView.vue?vue&type=style&index=0&id=2f9a2312&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9a2312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
